import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'Biometrics Verification',
  description:
    "If you've received an email requesting biometric verification, you can complete that step by taking a quick selfie.",
  linkLabel: 'Verify Now',
})
